module.exports = __webpack_public_path__ + "static/img/o2oPlatform.ff8ace1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/o2oPlatform.png
// module id = XwVo
// module chunks = 1